// extracted by mini-css-extract-plugin
export default {"FloatingLink":"FloatingLink_FloatingLink__2MsQr","FloatingLinkIcon":"FloatingLink_FloatingLinkIcon__L+sK3","FloatingLinkText":"FloatingLink_FloatingLinkText__ZvI9N"};